// Module
var code = "<p>Мемо ключ - это место, где Вы получаете мемо. Чтобы расшифровать мемо, Вы должны контролировать приватный ключ для публичного ключа.</p> <p>Используя пару из публичного/приватного ключей без разрешения на трату средств, Вы можете дать доступ к Вашим мемо в режиме &quot;только чтение&quot; третьим сторонам.</p> ";
// Exports
export default code;